import { message } from 'antd';
import { authHeader } from '../../../../helpers/auth-header';
import { client } from '../../../../actions';
import uri from '../../constants/uri';
import parseBackendFileErrorResponse from '../../../../helpers/parseBackendFileErrorResponse';
import { setAlertUrl } from '../actions/actions';
import { saveFileBlob } from '../../constants/fileCache';

const saveDebtsFile = async ({
  file,
  fileLoadingName,
  serviceCompanyId,
  fileId,
  dispatch,
}) => {
  const formData = new FormData();
  formData.append('excelFile', file);

  try {
    const response = await client.post(`${uri}/upload_register`, formData, {
      headers: {
        ...authHeader(),
      },
      params: {
        serviceCompanyId,
        fileLoadingName,
        fileId,
      },
      responseType: 'blob',
    });

    const contentType = response.headers['content-type'];
    const disposition = response.headers['content-disposition'];

    const isFile =
      disposition?.includes('attachment') ||
      contentType?.includes(
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      );

    if (isFile) {
      const blob = new Blob([response.data], { type: contentType });

      let fileName = 'ErrorsDebt.xlsx';
      if (disposition) {
        const utf8Match = disposition.match(/filename\*\s*=\s*UTF-8''(.+)/i);
        if (utf8Match?.[1]) fileName = decodeURIComponent(utf8Match[1]);
        else {
          const asciiMatch = disposition.match(/filename="(.+)"/i);
          if (asciiMatch?.[1]) fileName = asciiMatch[1];
        }
      }

      const newFileId = `errors-debts-${Date.now()}`;
      saveFileBlob(newFileId, blob);

      dispatch(
        setAlertUrl({
          fileId: newFileId,
          fileName,
          message:
            'Выполнена частичная загрузка данных. Ошибки и предупреждения представлены в файле',
        })
      );

      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      return;
    }

    const text = await response.data.text();
    const json = JSON.parse(text);

    if (json.result === 'Error') {
      const info = parseBackendFileErrorResponse(json.message);

      message.error(
        info.parsed
          ? `Внимание! Ошибка в строке №${info.value}.`
          : `Внимание! ${info.value}`,
        5
      );

      return 'Error';
    }

    message.success('Файл дебиторской задолженности загружен');
    return json.id;
  } catch (error) {
    console.error('Ошибка при сохранении файла:', error);

    if (error.response?.data instanceof Blob) {
      try {
        const text = await error.response.data.text();
        const json = JSON.parse(text);
        message.error(json.message || 'Ошибка при загрузке файла');
      } catch {
        message.error('При сохранении файла произошла ошибка');
      }
    } else {
      message.error('При сохранении файла произошла ошибка');
    }

    return 'Error';
  }
};

export default saveDebtsFile;
